const request = {
    message_rate_limited: 'Trop de messages ont été envoyés à ce destinataire. Réessayez plus tard.',
    invalid_input: "L'entrée est invalide. {{details}}",
    general: "Une erreur de requête s'est produite.",
    range_not_satisfiable: 'Plage non satisfaisable.',
    feature_not_supported: "Cette fonctionnalité n'est pas prise en charge dans l'environnement actuel.",
    rate_limited: 'Trop de requêtes. Veuillez réessayer plus tard.',
};
export default Object.freeze(request);
